import React from 'react';
import { Button, Row, Col } from 'react-bootstrap';
import { useInView } from 'react-intersection-observer';
import "../../css/Redes.css";
import InstagramFeed from './InstagramFeed'

const Redes = ({ theme = 'ltm' }) => {
    const { ref: tituloRef, inView: tituloInView } = useInView({ threshold: 0.1, triggerOnce: true });
    const { ref: textoRef, inView: textoInView } = useInView({ threshold: 0.1, triggerOnce: true });
    const { ref: botonesRef, inView: botonesInView } = useInView({ threshold: 0.1, triggerOnce: true });
    const { ref: imagenRef, inView: imagenInView } = useInView({ threshold: 0.1, triggerOnce: true });
    const { ref: imagenRef2, inView: imagenInView2 } = useInView({ threshold: 0.1, triggerOnce: true });


    return (
        <div id="redes" className={`${theme}-fondo-crema`}>
            <div className={`${theme}-redes-main-div pt-4 pb-5`}>
                <Row>
                    <Col md={6}>
                        <h1
                            ref={tituloRef}
                            className={`${theme}-titulo-redes mx-4 mx-md-5 pt-4 pb-md-5 pb-3 redes-transition-element ${tituloInView ? 'redes-animate-in-bottom' : ''
                                }`}
                        >
                            SEGUINOS <br/>EN REDES
                        </h1>

                        <div
                            ref={imagenRef}
                            className={`px-4 redes-transition-element d-md-none mb-1 ${imagenInView ? 'redes-animate-in-bottom' : ''
                                }`}
                        >
                            {/*<img src="/imagenes/Fotos/redes web 2.jpg" alt="Image 3" className="img-fluid" />*/}
                            <InstagramFeed/>
                        </div>

                        <div
                            ref={textoRef}
                            className={`mx-md-5 mx-4 redes-transition-element ${textoInView ? 'redes-animate-in-left' : ''
                                }`}
                        >
                            <h4>Seguinos para conocer promos, sorteos y novedades.</h4>
                            <h4>Descubrí la comunidad de Bingo Bahia que elige divertirse.</h4>

                        </div>
                        <div
                            ref={botonesRef}
                            className={`redes-transition-element mt-4 mt-lg-5 d-flex flex-column align-items-start ${botonesInView ? 'redes-animate-in-bottom' : ''}`}
                        >

                            <Button
                                className={`${theme}-btn-outline-light ${theme}-btn-hero btn-lg mx-md-5 mx-4 mb-3`}
                                onClick={() => window.open("https://www.instagram.com/bingo.bahia", "_blank", "noopener, noreferrer")}
                            >
                                <i className="bi bi-instagram"></i> Seguinos en Instagram
                            </Button>

                            <Button
                                className={`${theme}-btn-outline-light ${theme}-btn-hero btn-lg mx-md-5 mx-4 mt-3`}
                                onClick={() => window.open("https://www.facebook.com/bingo.bahia", "_blank", "noopener, noreferrer")}
                            >
                                <i className="bi bi-facebook"></i> Seguinos en Facebook
                            </Button>
                        </div>
                    </Col>

                    <Col
                        className={`px-5 pt-4 pb-5 d-none d-md-inline-block redes-transition-element ${imagenInView2 ? 'redes-animate-in-bottom' : ''
                            }`}
                        md={6}
                        ref={imagenRef2}
                    >
                        {/*<img src="/imagenes/Fotos/redes web 2.jpg" alt="Image 3" className="img-fluid" style={{ objectFit: 'cover', height: '100%' }} />*/}
                        <InstagramFeed/>
                    </Col>
                </Row>
            </div>
        </div>
    );
};

export default Redes;
